// The app is imported dynamically so window.config exists before any app module evaluates.
import { loadAppConfig, renderStartupError } from './config/appConfig';
import { applyBrandTheme } from './config/brandTheme';

window.addEventListener('unhandledrejection', function (event) {
  console.error('Unhandled promise rejection:', event.reason);
});

loadAppConfig()
  .then(brand => {
    applyBrandTheme(brand);
    return import('./js/react/index.js');
  })
  .catch(renderStartupError);
